// extracted by mini-css-extract-plugin
module.exports = {"showMoreSectionButton":"ShowMoreSectionButton_showMoreSectionButton__kYugj"};